import { useTranslation } from 'react-i18next';
import { setState, useStore, type AdminTab } from '../store/store';
import { useCalibration } from './calibrationStore';
import { BaseLayersAdmin } from './BaseLayersAdmin';
import { ImportAdmin } from './ImportAdmin';
import { ExportAdmin } from './ExportAdmin';
import { UsersAdmin } from './UsersAdmin';
import { DataImportAdmin } from './DataImportAdmin';
import { FieldSettingsAdmin } from './FieldSettingsAdmin';
import { DataExportAdmin } from './DataExportAdmin';
import { Icon } from '../panels/Icon';

const MAP_TABS: AdminTab[] = ['layers', 'import', 'export', 'users'];
const DATA_TABS: AdminTab[] = ['gamedata', 'dataexport', 'fields', 'users'];

export function AdminDrawer() {
  const { t } = useTranslation();
  const open = useStore((s) => s.adminOpen);
  const view = useStore((s) => s.view);
  if (!open) return null;
  const tabs = view === 'data' ? DATA_TABS : MAP_TABS;
  const close = () => {
    useCalibration.getState().set({ layerId: null, draft: null, points: [] });
    setState({ adminOpen: null, tool: { kind: 'none' } });
  };
  return (
    <aside className="drawer">
      <header className="insp-head">
        <div className="insp-title">
          <div className="name">{t('admin.title')}</div>
        </div>
        <button className="ghost icon-only" onClick={close} title={t('common.close')}>
          <Icon id="close" />
        </button>
      </header>
      <nav className="tabs">
        {tabs.map((k) => (
          <button key={k} className={open === k ? 'active' : ''} onClick={() => setState({ adminOpen: k })}>
            {t(`admin.tabs.${k}`)}
          </button>
        ))}
      </nav>
      <div className="tab-body">
        {open === 'layers' && <BaseLayersAdmin />}
        {open === 'import' && <ImportAdmin />}
        {open === 'export' && <ExportAdmin />}
        {open === 'users' && <UsersAdmin />}
        {open === 'gamedata' && <DataImportAdmin />}
        {open === 'dataexport' && <DataExportAdmin />}
        {open === 'fields' && <FieldSettingsAdmin />}
      </div>
    </aside>
  );
}
